import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

// Redux
import { connect } from 'react-redux';

// Components
import { Button } from '@material-ui/core';

import buysellapp_logo from '../../utils/imgs/buysellapp_logo.png';

const Default = ({
  nav: {
    website,
    website_loading
  }
}) => {

  let app_logo = buysellapp_logo;

  // -- Custom URL Logic --

  if(website?.website_logo) {
    app_logo = website?.website_logo;
  }

  // -- END: Custom URL Logic --

  return (
    <div className="no-post">

      {/* Logo image */}

      {/* Custom URL Logic */}
      {!website_loading ? (
        <img onClick={() => window.location = '/home'} className="modal__twitterIcon" src={app_logo} style={{height: '80px', cursor:'pointer'}} alt="logo" />
      ) : (
        // Placeholder
        <div style={{height: '80px'}}></div>
      )}
      
      <h1>This page doesn’t exist. </h1>
      <p>Try searching for something else.</p>

      <Button  
          onClick={() => window.location ='/home'}
          className="noChats__btn"
      >
          Go To Feed
      </Button>
    </div>
  );
};

Default.propTypes = {
  nav: PropTypes.object.isRequired, // Prop: Object representing navigation state
}

const mapStateToProps = state => ({

  // Mapping the states from the Redux store to the below props
  nav: state.nav
})

export default connect(mapStateToProps, { 

  // Connecting actions from redux to the component
})(Default);
